export enum AssetContentType {
  MP4 = "video/mp4",
  HLS = "application/x-mpegURL",
  MPD = "application/dash+xml",
  HSS = "application/vnd.ms-sstr+xml",
}
